import EmptyCol from './index.vue';

export {
  EmptyCol,
};

export default EmptyCol;
